import { Page } from '../../types'

const criminalCostAwards: Page[] = [
    {
        pageType: 'question',
        title: 'Criminal cost awards',
        name: 'criminal-cost-awards',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'criminal-cost-awards-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'criminal-cost-awards-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'criminal-cost-awards-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default criminalCostAwards
